import {
	GET_APPROVAL_STEP,
	APPROVE_STEP,
	UNAPPROVE_STEP
} from "./actions"

export function ApprovalStepsReducer(state = {}, action) {
	switch (action.type) {
		case `${UNAPPROVE_STEP}_FULFILLED`:
		case `${APPROVE_STEP}_FULFILLED`:
		case `${GET_APPROVAL_STEP}_FULFILLED`: {
			let newState = _.clone(state);
			const newItem = action.payload.data;
			const id = _.get(newItem, "id")
			newState[id] = newItem
			return newState;
		}
		default:
			return state;
	}
}

